import {
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';

import { Button, Stack, Text } from "@chakra-ui/react";
import { InnerBox } from 'view-layer/components/layout/InnerBox';

import { GenericKeyValue } from 'business-layer/types';
import { L10nContext } from 'business-layer/contexts/L10nContext';
import { eventbus, Events } from 'business-layer/helpers/eventbus';
import { detectLocale } from 'business-layer/helpers/user';



export const Footer = (props: any): JSX.Element => {
  const { labels }: { labels: GenericKeyValue } = useContext(L10nContext) as any;
  const [isDisabled, setDisabled] = useState<boolean>(false);

  const expDate = useMemo(() => {
    if (!props?.payment?.expiresAt) return null;
    const locale = detectLocale();
    const date = new Date(props.payment.expiresAt);
    const formatterDate = new Intl.DateTimeFormat(locale, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(date);
    return formatterDate;
  }, [props?.payment?.expiresAt])

  const onPay = () => {
    eventbus.emit(Events.FormSubmit);
  };

  //TODO: uncomment for cancel
  // const onCancel = () => {
  //   eventbus.emit(Events.FormReset);
  // };

  useEffect(() => {
    eventbus.on(Events.FormDisable, () => setDisabled(true));
    eventbus.on(Events.FormEnable, () => setDisabled(false));
    return () => {
      eventbus.off(Events.FormDisable);
      eventbus.off(Events.FormEnable);
    }
  });

  return (
    <InnerBox
      borderTopStyle="solid"
      borderTopColor="#f8f9fa"
      borderTopWidth="2px"
      pt={4}
      pb={4}
    >
      <Stack
        direction="row"
        justify="space-between"
        align="baseline"
        spacing={2}
      >
        <Text fontStyle="italic" fontSize="sm">
          {expDate && (<>{labels?.expiresAt} {expDate}</>)}
        </Text>
        <Button variant="dark" onClick={onPay} data-testid="footer-submit-buttom" isDisabled={isDisabled}>
          {labels?.pay}
        </Button>
        {/* <Button colorScheme='blue' variant='light' onClick={onCancel} data-testid="footer-cancel-buttom">
          {labels?.cancel}
        </Button> */}
      </Stack>
    </InnerBox>
  )};
